// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_recorder_recordingQueryVariables = Exact<{
  id: Scalars['Int64']['input'];
}>;


export type easyreels_user_recorder_recordingQuery = { __typename?: 'Query', recording?: { __typename?: 'Recording', id: number, status: RecordingStatus, error: string, segments: { __typename?: 'SegmentsConnection', nodes: Array<{ __typename?: 'Segment', index: number, bytes: number, startMs: number, endMs: number, downloadURL?: string | null, capture: { __typename?: 'Capture', facingMode: string, width: number, height: number, orientation: Orientation } }> } } | null };


export function $easyreels_user_recorder_recording(variables: easyreels_user_recorder_recordingQueryVariables, opts?: { revalidate?: boolean }): easyreels_user_recorder_recordingQuery {
	return $easyreels_gql_user_request(`query easyreels_user_recorder_recording(\u0024id: Int64!) {
  recording(id: \u0024id) {
    id
    status
    error
    segments {
      nodes {
        index
        bytes
        startMs
        endMs
        capture {
          facingMode
          width
          height
          orientation
        }
        downloadURL
      }
    }
  }
}`, variables, opts) as easyreels_user_recorder_recordingQuery
}

}
